import { Navigate, useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { usePortalAuth } from "@/context/PortalAuthContext";

export default function PortalProtectedRoute({ children }) {
  const { profile, loading } = usePortalAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F1222]">
        <Icons.Loader2 className="h-7 w-7 animate-spin text-[#F5A623]" />
      </div>
    );
  if (!profile) {
    // Preserve the full intended destination (pathname + search + hash) so that a client
    // who lands on any protected /portal/... route while unauthenticated is returned there
    // after login. Passed via React Router state only — never as a public query parameter.
    const returnTo = location.pathname + location.search + location.hash;
    return <Navigate to="/portal/login" state={{ returnTo }} replace />;
  }
  return children;
}
